import React, { useState } from "react";
import { baseUrl } from "@jumbo/constants/baseUrl";
import FileUploader from "../Media/FileUploader";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  title: {
    color: theme.palette.primary.main,
    marginBlock: "16px",
    fontWeight: "bold",
  },
  noLeftBorder: {
    borderRight: "none",
    borderRadius: "4px 0px 0px 4px",
  },
  inputContainer: {
    width: "100%",
    display: "flex",
  },
  leftButton: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
}));

const BlogFilePicker = ({ type, setCurrMedia }) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const [media, setMedia] = useState(null);
  const [openVideoUploader, setOpenVideoUploader] = useState(false);
  const [viedo, setViedo] = useState(null);

  const [blogImage, setblogImage] = useState("");
  const [blogvideo, setblogVideo] = useState("");

  const handleSelectImage = (selected) => {
    setMedia(selected);
    const extension = selected.name
      .split(".")
      .pop()
      .toLowerCase();
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    if (imageExtensions.includes(extension)) {
      setblogImage(`${baseUrl}file/get/${selected.name}`);
    } else {
      setblogVideo(`${baseUrl}file/get/${selected.name}`);
    }
  };

  const handleSelectVideo = (selected) => {
    setViedo(selected);
    const extension = selected.name
      .split(".")
      .pop()
      .toLowerCase();
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    if (imageExtensions.includes(extension)) {
      setblogImage(`${baseUrl}file/get/${selected.name}`);
    } else {
      setblogVideo(`${baseUrl}file/get/${selected.name}`);
    }
  };

  const handleAdd = () => {
    if (type === "Image" && blogImage) {
      setCurrMedia(blogImage);
    } else if (type === "Video" && blogvideo && blogImage) {
      setCurrMedia({ src: blogvideo, preview: blogImage });
    } else {
      if (blogImage && !blogvideo && type !== "Video") {
        setCurrMedia((prev) => [...prev, { type: "Image", file: blogImage }]);
      } else if (blogImage && blogvideo) {
        setCurrMedia((prev) => [
          ...prev,
          { type: "Video", file: { src: blogvideo, preview: blogImage } },
        ]);
      }
    }
    setblogImage("");
    setblogVideo("");
  };

  return (
    <>
      {type === "Image" ? (
        <Grid item xs={12}>
          <Typography className={classes.title}>تصویر</Typography>
          <Box className={classes.inputContainer}>
            <TextField
              id="socoreField"
              label="تصویر"
              variant="outlined"
              className={classes.formControl}
              value={blogImage}
              onChange={(e) => setblogImage(e.target.value)}
              InputProps={{
                classes: {
                  notchedOutline: classes.noLeftBorder,
                },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenFileUploader(true)}
              className={classes.leftButton}
            >
              انتخاب
            </Button>
          </Box>
        </Grid>
      ) : type === "Video" ? (
        <>
          <Grid item xs={12}>
            <Typography className={classes.title}>تصویر ویدئو</Typography>
            <Box className={classes.inputContainer}>
              <TextField
                id="socoreField"
                label="تصویر"
                variant="outlined"
                className={classes.formControl}
                value={blogImage}
                onChange={(e) => setblogImage(e.target.value)}
                InputProps={{
                  classes: {
                    notchedOutline: classes.noLeftBorder,
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenFileUploader(true)}
                className={classes.leftButton}
              >
                انتخاب
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.title}>ویدئو</Typography>
            <Box className={classes.inputContainer}>
              <TextField
                id="socoreField"
                label="ویدئو"
                variant="outlined"
                className={classes.formControl}
                value={blogvideo}
                onChange={(e) => setblogVideo(e.target.value)}
                InputProps={{
                  classes: {
                    notchedOutline: classes.noLeftBorder,
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenVideoUploader(true)}
                className={classes.leftButton}
              >
                انتخاب
              </Button>
            </Box>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12}>
            <Typography className={classes.title}>تصویر</Typography>
            <Box className={classes.inputContainer}>
              <TextField
                id="socoreField"
                label="تصویر"
                variant="outlined"
                className={classes.formControl}
                value={blogImage}
                onChange={(e) => setblogImage(e.target.value)}
                InputProps={{
                  classes: {
                    notchedOutline: classes.noLeftBorder,
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenFileUploader(true)}
                className={classes.leftButton}
              >
                انتخاب
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.title}>ویدئو</Typography>
            <Box className={classes.inputContainer}>
              <TextField
                id="socoreField"
                label="ویدئو"
                variant="outlined"
                className={classes.formControl}
                value={blogvideo}
                onChange={(e) => setblogVideo(e.target.value)}
                InputProps={{
                  classes: {
                    notchedOutline: classes.noLeftBorder,
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenVideoUploader(true)}
                className={classes.leftButton}
              >
                انتخاب
              </Button>
            </Box>
          </Grid>
        </>
      )}
      <Box display={"flex"} justifyContent={"center"} marginTop={"16px"}>
        <Button variant="contained" color="primary" onClick={handleAdd}>
          افزودن
        </Button>
      </Box>

      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelectGallery={(selected) => handleSelectImage(selected)}
        gallerySlected={media}
        gallerySelctor={true}
      />
      <FileUploader
        selectMode
        open={openVideoUploader}
        handleClose={() => setOpenVideoUploader(false)}
        handleSelectGallery={(selected) => handleSelectVideo(selected)}
        gallerySlected={viedo}
        gallerySelctor={true}
      />
    </>
  );
};

export default BlogFilePicker;
